/**
 * FAQ Schema Component
 * Generates JSON-LD structured data for FAQ sections
 * 
 * @param {Array} faqs - Array of FAQ objects with question and answer properties
 * @example
 * <FAQSchema faqs={[
 *   { question: "What is water hardness?", answer: "Water hardness refers to..." },
 *   { question: "Do I need a water softener?", answer: "Whether you need..." }
 * ]} />
 */
export default function FAQSchema({ faqs }) {
  if (!faqs || faqs.length === 0) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

